import { render, staticRenderFns } from "./EmailList.vue?vue&type=template&id=e83fe7d4&scoped=true"
import script from "./EmailList.vue?vue&type=script&lang=js"
export * from "./EmailList.vue?vue&type=script&lang=js"
import style0 from "./EmailList.vue?vue&type=style&index=0&id=e83fe7d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83fe7d4",
  null
  
)

export default component.exports